import { Component, OnInit, Injector, OnDestroy, Inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ProfileService } from "src/app/shared/service/profile-ms-teams.service";
import { DomSanitizer } from "@angular/platform-browser";
import { UserService } from "src/app/shared/service/user.service";
import { EmployeeService } from "src/app/shared/service/employee.service";

const GRAPH_ENDPOINT_GET_PHOTO =
  "https://graph.microsoft.com/v1.0/me/photo/$value";

@Component({
  selector: "profile-ms-teams",
  styleUrls: ["./profile-ms-teams.component.css"],
  templateUrl: "./profile-ms-teams.component.html",
  providers: [ProfileService],
})
export class ProfileComponent implements OnInit {
  isImageLoading: boolean = false;
  imageToShow: any;
  empCode_ID: any;
  empCode: any;

  constructor(
    private _profileService: ProfileService,
    private domSanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private _userService: UserService,
    private empsvc: EmployeeService
  ) {}

  ngOnInit() {
    this.empCode = this._userService.getEmpCode();
    // To get user's photo
    // this.getProfilePicture();
    this.route.params.subscribe((params) => {
      this.empCode_ID = params["empCode_ID"];
    });

    console.log("=======empCode_ID===", this.empCode_ID);
    if (this.empCode_ID) {
      const temp_val = this.empCode_ID.split("-");
      this.empsvc
        .getOffboardingDetailsById(temp_val[1])
        .subscribe((data: any) => {
          const finalData = data;
          console.log(
            "======weekend employee=======1",
            finalData,
            finalData.EmpCode,
            this.empCode
          );
          if (finalData != null && finalData.EmpCode == this.empCode) {
            console.log("======If=======1");
            // window.location.href =
            //   "https://qa-winemployee.azurewebsites.net/" +
            //   "myprofile/" +
            //   this.empCode;
          } else {
            console.log("======Else=======1");
          //   window.location.href =
          //     "https://qa-winhr.azurewebsites.net/" +
          //     "Offboardinglist/tabIndex/0";
          }
        });
    }
  }

  getProfilePicture() {
    // this.isImageLoading = true;
    // this._profileService.getImage(GRAPH_ENDPOINT_GET_PHOTO).subscribe(
    //   (blob) => {
    //     this.isImageLoading = false;
    //     var urlCreator = window.URL || window.URL;
    //     this.imageToShow = this.domSanitizer.bypassSecurityTrustUrl(
    //       urlCreator.createObjectURL(blob)
    //     );
    //   },
    //   (error) => {
    //     this.isImageLoading = false;
    //     console.log(error);
    //   }
    // );
  }

  createImageFromBlob(image: Blob) {
    // let reader = new FileReader();
    // reader.addEventListener(
    //   "load",
    //   () => {
    //     // console.log(reader.result);
    //     const imgRes: any = reader.result;
    //     this.imageToShow = this.domSanitizer.bypassSecurityTrustUrl(imgRes);
    //   },
    //   false
    // );
    // if (image) {
    //   reader.readAsDataURL(image);
    // }
  }
}
